import { useId } from "react";

// Steerly compass mark. Drawn monochrome via `currentColor` so it inherits the
// surrounding text color and themes correctly in light/dark — matching how the
// brand mark renders in the sidebar, activity bar, and welcome view.
//
// The needle is knocked out of a solid disc with an SVG <mask>; mask values are
// luminance (#fff = keep, #000 = cut), not theme colors, so the single
// `fill="currentColor"` on the disc drives the whole mark. The mask id is
// per-instance (useId) because ActivityBar and SessionRail render a Logo
// simultaneously and a shared id="…" would be a duplicate in one DOM.
//
// React's useId() embeds colons (e.g. ":r0:"); those break `url(#…)` mask
// references in WebKit (Safari + the Tauri/native macOS WKWebView we ship),
// which treats the colon as an XML namespace delimiter, so the mark renders
// as a solid disc with no needle. Replace colons with hyphens to keep the id
// unique but reference-safe.
export function Logo() {
  const maskId = useId().replace(/:/g, "-");
  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <mask id={maskId}>
        <circle cx="24" cy="24" r="17" fill="#fff" />
        <polygon points="24,16 31,29 17,29" fill="#000" transform="rotate(12 24 24)" />
        <rect x="22.4" y="24" width="3.2" height="19" fill="#000" transform="rotate(12 24 24)" />
        <rect x="22.4" y="24" width="3.2" height="19" fill="#000" transform="rotate(132 24 24)" />
        <rect x="22.4" y="24" width="3.2" height="19" fill="#000" transform="rotate(252 24 24)" />
      </mask>
      <circle cx="24" cy="24" r="17" fill="currentColor" mask={`url(#${maskId})`} />
    </svg>
  );
}
